import { render } from "./contractSwitchModal.vue?vue&type=template&id=5130cebe&ts=true"
import script from "./contractSwitchModal.vue?vue&type=script&lang=ts"
export * from "./contractSwitchModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__